import Loadable from "app/components/Loadable";
import { PERMISSIONS } from "app/utils/permissions";
import { lazy } from "react";

const Analytics = Loadable(lazy(() => import("./Analytics")));

const dashboardRoutes = [
  {
    path: "/dashboard/default",
    element: <Analytics />,
    permission: PERMISSIONS.Dashboard.Menu,
  },
];

export default dashboardRoutes;
